<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 4C2.55228 4 3 3.55228 3 3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3C1 3.55228 1.44772 4 2 4ZM6 2C5.5 2 5 2.51184 5 3C5 3.48816 5.5 4 6 4H14C14.5 4 15 3.55228 15 3C15 2.44772 14.5 2 14 2H6ZM6 7C5.5 7 5 7.44772 5 8C5 8.55228 5.5 9 6 9H14C14.5 9 15 8.55228 15 8C15 7.44772 14.5 7 14 7H6ZM6 12C5.5 12 5 12.4477 5 13C5 13.5523 5.5 14 6 14H14C14.5 14 15 13.5523 15 13C15 12.4477 14.5 12 14 12H6ZM3 8C3 8.55228 2.55228 9 2 9C1.44772 9 1 8.55228 1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8ZM2 14C2.55228 14 3 13.5523 3 13C3 12.4477 2.55228 12 2 12C1.44772 12 1 12.4477 1 13C1 13.5523 1.44772 14 2 14Z"
    fill="currentColor"
  />
</svg>
